import React from 'react';
import PropTypes from 'prop-types';

import studersLogo from './logo/studers.svg';
import studystoreLogo from './logo/studystore.svg';
import vandijkLogo from './logo/vandijk.svg';
import learnidLogo from './logo/learnid.svg';
import studieshopLogo from './logo/studieshop.svg';

const logoArray = [studersLogo, studystoreLogo, vandijkLogo, studieshopLogo];

const logoForBrandName = brandName => (brandName && logoArray.find(logoPath => logoPath.indexOf(brandName) > -1)) || learnidLogo;

const BrandLogo = ({ brandName, brandUrl }) => (
  <a href={brandUrl}>
    <img alt={brandName} className="mb-0 mb-lg-4" id="brandLogo" src={logoForBrandName(brandName)} />
  </a>
);

BrandLogo.propTypes = {
  brandName: PropTypes.string,
  brandUrl: PropTypes.string
};

BrandLogo.defaultProps = {
  brandName: '',
  brandUrl: ''
};

export default BrandLogo;
